// extracted by mini-css-extract-plugin
export var active = "_e2-2";
export var recordingDot = "_e2-1";
export var recordingIndicator = "_e2-0";